<template lang='pug'>
  .faq
    faq-search

    template(v-if='isMobile')
      template(v-if='currentView')
        component(v-bind:is='currentView' :isMobile='isMobile')

      template(v-else)
        .sections
          .section-line
          .section(v-for='section in sections')
            .row(@click='gotoSection(section)')
              .col-xs-10
                .section-title(v-text='section.name')
              .col-xs-2
                .svg-icon.chevron-right.right-arrow
            .section-line

    template(v-else)
      .row
        .col-lg-2.col-md-3.col-sm-3.col-xs-3
          .title(v-t='"navigation.links.faq"')
          ul.sections
            li(v-for='section in sections')
              a.section(href='javascript:void(0)' :class='{ "router-link-exact-active": activeSection === getSlug(section) }' @click='gotoSection(section)' v-text='section.name')
        .col-lg-10.col-md-9.col-sm-9.col-xs-9
          transition(name='fade', mode='out-in')
            section-show(:section='sections[0]' v-if='!currentView')
            component(v-bind:is='currentView')
</template>

<script>
import UrlMixin from './url-mixin'
import FaqSearch from './search.vue'
import Articles from './articles.vue'
import ArticleShow from './article-show.vue'
import SectionShow from './section-show.vue'
import { fullUrl } from '@/modules/services/utilities'
import { createNamespacedHelpers } from 'vuex'
import faq from '@/store/modules/faq'
import { dynamicLoadStore } from '@/mixins/store-util'

const { mapState, mapMutations, mapActions } = createNamespacedHelpers('faq')

export default {
  name: 'FaqIndex',

  components: {
    FaqSearch,
    Articles,
    ArticleShow,
    SectionShow
  },

  mixins: [
    dynamicLoadStore({ faq })
  ],

  props: ['currentView'],

  computed: {
    ...mapState(['sections', 'activeSection']),
    isMobile: () => vueSupport.isMobile
  },

  created () {
    this.updateActiveSection()

    this.fetchSections().then(() => {
    }).catch(e => {
      this.$store.commit('setNotification', {
        type: 'error',
        msg: this.$t('notifications.error')
      })
    })

    this.$store.commit('setSeoMetaTitle', this.$t('navigation.links.faq'))
    this.$store.commit('setSeoOgUrl', fullUrl(this.$route.path))
    this.$store.commit('setSeoUpdate', true)
  },

  methods: {
    ...mapMutations(['setActiveSection', 'setArticlesPage']),
    ...mapActions(['fetchSections']),

    gotoSection (section) {
      if (!this.isMobile) {
        this.updateActiveSection()
      }
      this.setArticlesPage(1)

      this.$router.push({ name: 'faq-section-show',
        params: {
          sectionId: this.getSlug(section) }
      })
    },

    updateActiveSection () {
      let activeSection = this.activeSection

      if (this.$route.params['sectionId']) {
        activeSection = this.$route.params['sectionId']
      } else if (!activeSection && this.$route.meta.entityType !== 'search') {
        activeSection = 'top-questions'
      }

      this.setActiveSection(activeSection)
    },

    getSlug (obj) {
      return UrlMixin.getSlug(obj)
    }
  }
}
</script>

<style lang='scss'>
  .faq {
    @include media-breakpoint-down(md) {
      margin-bottom: 25px;
    }

    .router-link-exact-active {
      color: $brand-primary;
    }

    .col-lg-10 {
      margin-bottom: 50px;
      padding-left: 25px;
    }

    .title {
      @include font-weight-bold;
      font-size: 14px;
      text-transform: uppercase;
      margin-bottom: 10px;
    }

    .sections {
      margin-bottom: 20px;

      li {
        margin-top: 15px;
      }

      @include media-breakpoint-down(md) {
        margin-left: 8px;
        margin-right: 8px;
      }
    }

    .section {
      margin-top: 13px;
    }

    .section-line {
      height: 1px;
      margin-top: 5px;
      background-color: $grey;
    }

    .section-title {
      @include media-breakpoint-down(md) {
        padding-left: 15px;
      }
    }

    .right-arrow {
      height: 20px;
      width: 20px;
    }
  }
</style>
